import { getRoute } from '@/app/olkypass/utils/routes'
import { Routes } from '../router'

export const getRoutesWithoutPadding = (session_uuid: string) => [
  getRoute(Routes.flow_step, { session_uuid, block: 'documents', step: 'kyc-session-iframe' })
]
